import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

enum BOOKKEEPING_ROUTE_NAMES {
  exportToOptima = "Bookkeeping Optima",
  exportToSymfonia = "Bookkeeping Symfonia",
  exportToJPK = "Bookkeeping JPK",
  closeMonth = "Bookkeeping Close Month",
}

const BookkeepingRoutes: Array<CustomRouteConfig> = [
  {
    name: BOOKKEEPING_ROUTE_NAMES.exportToOptima,
    path: "bookkeeping-export-optima",
    component: () => import(/* webpackChunkName: "bookkeeping" */ "@/views/bookkeeping/BookkeepingOptimaView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookKeepingRead] },
  },
  {
    name: BOOKKEEPING_ROUTE_NAMES.exportToSymfonia,
    path: "bookkeeping-export-symfonia",
    component: () => import(/* webpackChunkName: "bookkeeping" */ "@/views/bookkeeping/BookkeepingSymphonyView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookKeepingRead] },
  },
  {
    name: BOOKKEEPING_ROUTE_NAMES.exportToJPK,
    path: "bookkeeping-export-JPK",
    component: () => import(/* webpackChunkName: "bookkeeping" */ "@/views/bookkeeping/BookkeepingJPKView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookKeepingRead] },
  },
  {
    name: BOOKKEEPING_ROUTE_NAMES.closeMonth,
    path: "bookkeeping-close-month",
    component: () => import(/* webpackChunkName: "bookkeeping" */ "@/views/bookkeeping/BookkeepingCloseMonthView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookKeepingRead] },
  },
];

export { BookkeepingRoutes };
export default BookkeepingRoutes;
